export function splitArrayIntoChunks(arr, count = 1) {
    const chunks = [];
    let i = 0;
    const n = arr.length;
    const itemCount = Math.ceil(n / count);
    while (i < n) {
        chunks.push(arr.slice(i, i += itemCount));
    }
    return chunks;
}

export function scrollToError() {
    setTimeout(() => {
        // `.validation-error-summary` is the fallback for validation errors that
        // belong to no single field, so a failed submit is never silent.
        const elements = document.querySelectorAll('.has-error, .validation-error-summary');
        if (elements.length) {
            elements[0].scrollIntoView();
        }
    }, 300);
}
